import getHelper from '../../../services/getHelper';

export default getHelper('/certifications/:id');
